import React from 'react'

const Gifting_Products_Card = () => {
  return (
    <div>
    <a href="/shop">

<div className="group max-w-sm overflow-hidden bg-white border border-gray-200 rounded-sm hover:shadow-md  ">

<div className='w-full grid place-items-center'>
<img className="px-0 group-hover:scale-105 transition-transform duration-150 py-2.5 w-4/6 rounded-t-lg" src="/images/Groccery/dairymilk.jpg" alt="" />

</div>

<div className="px-1 pb-1 lg:px-2 lg:py-2">

<h5 className="text-sm font-semibold tracking-tight text-gray-900 ">Apple Watch Series 7 GPSr</h5>


<div className="w-full">
<div className='py-2'>
    <span className=' font-semibold text-md px-1'> ₹ 787</span> 
    <span className='text-gray-web line-through text-sm font-light p-1'>₹ 1242</span>
    </div>
<a href="/" className="w-full block mt-2 text-white bg-sky-600 hover:bg-sky-600/90 focus:ring-4 focus:outline-none  font-medium rounded-sm text-sm  lg:px-4 px-2.5 py-2 text-center ">Add to cart</a>
</div>
</div>
</div>
</a> 
 </div>
  )
}

export default Gifting_Products_Card